import { render, staticRenderFns } from "./Kiosks.vue?vue&type=template&id=4a413f9e&scoped=true"
import script from "./Kiosks.vue?vue&type=script&lang=ts"
export * from "./Kiosks.vue?vue&type=script&lang=ts"
import style0 from "./Kiosks.vue?vue&type=style&index=0&id=4a413f9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a413f9e",
  null
  
)

export default component.exports